import { z } from 'zod';
import { COMPANY_LIFECYCLES, COMPANY_TYPES, OFFICES, LEAD_SOURCES } from '../enums.js';
import { optionalText, patchSchemaOf } from './common.js';
export const companyInputSchema = z.object({
    name: z.string().trim().min(2, 'Company name is required').max(200),
    nameAr: optionalText,
    type: z.enum(COMPANY_TYPES).default('other'),
    lifecycle: z.enum(COMPANY_LIFECYCLES).default('lead'),
    source: z.enum(LEAD_SOURCES).default('other'),
    office: z.enum(OFFICES).default('beirut'),
    countryCode: z.string().trim().length(2).toUpperCase().default('LB'),
    city: optionalText,
    address: optionalText,
    website: optionalText,
    email: z.union([z.string().trim().toLowerCase().email(), z.literal('')]).optional(),
    phone: optionalText,
    /** Client's Lebanese Ministry of Finance number. Plain text - no VAT logic. */
    financialNumber: optionalText,
    notes: optionalText,
    ownerId: z.string().uuid().optional(),
});
export const companyUpdateSchema = patchSchemaOf(companyInputSchema);
//# sourceMappingURL=company.js.map